import { render } from "./LensSelector.vue?vue&type=template&id=c4294a5c"
import script from "./LensSelector.vue?vue&type=script&lang=js"
export * from "./LensSelector.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"LensSelector.vue"]])

export default __exports__